import { render, staticRenderFns } from "./AddNewQuestion.vue?vue&type=template&id=b4a453b0&"
import script from "./AddNewQuestion.vue?vue&type=script&lang=js&"
export * from "./AddNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddNewQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports